import React from "react";
import PropTypes from "prop-types";

import styles from "./SuspensionBanner.module.css";

export function SuspensionBanner({ suspensionInfo }) {
  const suspendedPlatforms = suspensionInfo
    .filter((platform) => platform.status === "suspended")
    .map((platform) => platform.name)
    .join(", ");

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        User is suspended from {suspendedPlatforms}
      </div>
    </div>
  );
}

SuspensionBanner.propTypes = {
  suspensionInfo: PropTypes.array,
};
